import React, { Component } from "react";
import { connect } from "react-redux";
import { SecondaryButton, PrimaryButton } from "components/Global/Buttons";
import RichTextEditor from "../Global/RichTextEditor";
import CloseIcon from "lib/ui/close";
import { downloadDealPdf, dealSetProperty, fetchDeal } from '../../store/state/deal';
import { Dialog, DialogContent, DialogTitle, DialogActions, Button } from "@material-ui/core";

const ACTIONS = {
  SAVE: 'SAVE'
  , SAVING: 'SAVING'
  , EXPORT: 'EXPORT'
  , EXPORTING: 'EXPORTING'
};

class DealPdfSummaryModal extends Component {

  state = {
    action: null
    , actionStep: null
    , footnotesForPdfExport: null
  }

  componentWillMount() {
    const { deal } = this.props;
    this.setState({ footnotesForPdfExport: deal.footnotesForPdfExport });
  }

  componentDidUpdate(prevProps) {
    const { deal, isLoading } = this.props;

    // only do something if isLoading has changed from true to false
    if (prevProps.isLoading !== isLoading && !isLoading) {
      const { action, actionStep } = this.state;
      const switchKey = `${action}-${actionStep}`;

      switch (switchKey) {
        // SAVE-SAVING && isLoading = false 
        // means that we only planned to save and it saved already
        case `${ACTIONS.SAVE}-${ACTIONS.SAVING}`:
          this.props.handleClose();
          break;

        // EXPORT-SAVING && isLoading = false 
        // means that saving is done so now we can export pdf
        case `${ACTIONS.EXPORT}-${ACTIONS.SAVING}`:
          this.setState({ action: ACTIONS.EXPORT, actionStep: ACTIONS.EXPORTING })
          this.props.downloadDealPdf({ dealIds: [deal.id] });
          break;

        // EXPORT-EXPORTING && isLoading = false 
        // means that saving && export finished
        case `${ACTIONS.EXPORT}-${ACTIONS.EXPORTING}`:
          // TODO: Are we automatically closing?
          this.props.handleClose();
          break;

        default:
          console.log(`missed a case:${switchKey}`);
      }
    }
  }

  setAction = (action) => {
    const { deal } = this.props;
    this.setState({ action, actionStep: ACTIONS.SAVING });

    const { footnotesForPdfExport } = this.state;
    this.props.dealSetProperty({
      dealId: deal.id
      , property: { footnotesForPdfExport }
      , postUpdateCall: () => this.props.fetchDeal(deal.id)
    });
  }

  onEditorStateChange = (footnotesForPdfExport) => {
    this.setState({ footnotesForPdfExport });
  }

  render() {
    const { isOpen, handleClose, deal } = this.props;

    return (
      <Dialog
        modal='true'
        maxWidth="md"
        open={isOpen}
      >
        <div style={{ display: 'flex' }}>
          <DialogTitle>Footnotes for Deal Summary PDF Export</DialogTitle>
          <Button onClick={handleClose} style={{ marginLeft: 'auto' }}>
            <CloseIcon />
          </Button>
        </div>

        <DialogContent style={{ maxHeight: "500px", overflow: "auto" }}>
          <RichTextEditor
            htmlString={deal.footnotesForPdfExport}
            handleUpdate={this.onEditorStateChange}
            maxColumns={6}
            maxLength={1000}
          ></RichTextEditor>
        </DialogContent>

        <DialogActions>
          <SecondaryButton onClick={() => this.setAction(ACTIONS.SAVE)} style={{ marginRight: 'auto' }}>SAVE</SecondaryButton>
          <PrimaryButton onClick={() => this.setAction(ACTIONS.EXPORT)}>EXPORT</PrimaryButton>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = ({ deal }) => ({
  deals: deal.deals
  , isLoading: deal.isLoading
});

export default connect(mapStateToProps, {
  downloadDealPdf
  , dealSetProperty
  , fetchDeal
})((DealPdfSummaryModal));
